import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Card: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID }) => (
    <section className={`${styles.card} ${className}`} data-testid={testId}>
        {children}
    </section>
);

export default Card;
